import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'

import './scss/style.scss'
import './scss/recaptcha.scss'
import CookiesProvider from 'react-cookie/es6/CookiesProvider'

ReactDOM.render(
    <React.StrictMode>
        <CookiesProvider>
            <Suspense fallback={<p>loading</p>}>
                <App/>
            </Suspense>
        </CookiesProvider>
    </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
